<template>
    <v-dialog persistent v-model="dialogOpen" max-width="450">
        <v-card class="pa-3" v-if="student">
            <div v-if="!student.name" class="pa-3">
                <v-card-title class="pl-0">New Student</v-card-title>
                <v-flex xs5>
                    <v-select
                        hide-details
                        :items="newStudents"
                        label="New Student"
                        ref="newStudent"
                        v-model="newStudent"
                        :rules="[]"
                        box
                        item-text="`${data.item.engName} - ${data.item.hebName} (${data.item.class})` "
                    >
                        <template slot="selection" slot-scope="data">
                            {{ data.item.engName }} -
                            {{ data.item.hebName }}
                        </template>
                        <template slot="item" slot-scope="data">
                            <v-list-tile-content>
                                <v-list-tile-title
                                    v-html="
                                        `${data.item.engName} - ${
                                            data.item.hebName
                                        }`
                                    "
                                >
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </template>
                    </v-select>
                </v-flex>
            </div>
            <div v-if="student.name">
                <v-layout row justify-space-between>
                    <v-card-title
                        >{{ student.name }}
                        -
                        {{ student.hebName }}
                        ({{ student.class }})</v-card-title
                    >
                    <v-card-actions>
                        <v-btn
                            class="text-xs-right"
                            small
                            color="success"
                            @click="resetPrice"
                            >Reset Price</v-btn
                        >
                    </v-card-actions>
                </v-layout>
                <v-divider></v-divider>
                <v-layout row class="pa-3 mt-2">
                    <v-spacer> </v-spacer>
                    <v-layout row justify-end>
                        <div v-if="!editingAmount">
                            <v-layout row>
                                <v-card-title
                                    class="py-0"
                                    style="background-color: #FFF; border-style: solid; border-color: #5cb860;"
                                >
                                    <div class="font-weight-medium">
                                        ${{ getPaymentAmount(student) }}
                                    </div>
                                </v-card-title>
                                <v-card-actions class="py-0">
                                    <v-btn
                                        @click="edit"
                                        flat
                                        icon
                                        class="text-xs-right"
                                        color="success"
                                    >
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-layout>
                        </div>
                        <div v-else>
                            <v-layout row>
                                <v-text-field
                                    class="mr-3 ml-3"
                                    label="Amount"
                                    placeholder="Amount"
                                    v-model="paymentAmount"
                                    @input="updateTotal(student)"
                                    prefix="$"
                                    type="number"
                                    hide-details
                                ></v-text-field>
                                <v-btn
                                    flat
                                    class="mr-1"
                                    @click="() => rollbackEditingAmount()"
                                    small
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    flat
                                    @click="editingAmount = false"
                                    small
                                    color="success"
                                >
                                    save
                                </v-btn>
                            </v-layout>
                        </div>
                    </v-layout>
                </v-layout>
                <v-layout
                    row
                    wrap
                    class="pa-3 pb-2"
                    v-if="!student.isEnrolled || changeFromNone(student)"
                >
                    <v-flex
                        style="max-width: 200px;"
                        class="pl-0 pb-0 pr-2"
                        xs12
                        sm6
                        md2
                        v-for="charge in student.charges"
                    >
                        <v-text-field
                            @input="updateTotal(student)"
                            hide-details
                            prefix="$"
                            v-model="charge.paymentAmount"
                            :label="charge.name"
                            type="number"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout
                    v-if="!student.isEnrolled || changeFromNone(student)"
                    row
                    justify-end
                    class="font-weight-medium headline text-success mt-0 pr-3 pb-3"
                >
                    <div class="pr-1">
                        Total:
                    </div>
                    <div class="">
                        {{ student.total | currency }}
                    </div>
                </v-layout>
            </div>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="cancel" color="default" dark>
                    Close
                </v-btn>
                <v-btn
                    v-if="student.name"
                    color="success"
                    :loading="processing"
                    @click="save"
                >
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { groupBy, onlyUnique, getDomain, sum } from "../../utils/helpers.js";
import { loadOptions } from "../../utils/smLookup.js";

export default {
    props: {
        student: Object,
        account: Object,
        ykAccount: Object,
        refresh: Function,
        country: String,
        newStudentSelected: Function,
        newStudents: Array,
    },
    data() {
        return {
            dialogOpen: false,
            dates: [],
            rates: [],
            classes: [],
            bunks: [],
            editingAmount: false,
            paymentAmount: "",
            originalAmount: 0,
            processing: false,
            newStudent: {},
            insuranceCompanies: [],
            charges: [],

            gradesSetup: [],

            regID: "",

            rules: {
                required: (value, duration) => {
                    return duration == "NONE" || !!value || "Required.";
                },
            },
        };
    },
    async created() {
        await this.loadRegID();
        await this.loadGradesSetup();
        await this.loadCharges();
    },
    computed: {},
    watch: {
        newStudent(newValue, oldValue) {
            this.newStudentSelected(newValue);
        },
        student(newValue, oldValue) {
            this.paymentAmount = newValue.enrollment.amount;
        },
    },
    methods: {
        async loadRegID() {
            this.regID = "GC2020";
        },
        async loadInsuranceCompanies() {
            this.insuranceCompanies = await loadOptions("InsuranceCompany");
        },
        hasDayCamp(student) {
            return this.gradesSetup.find((g) => g.grade == student.class)
                .isYKCAvail;
        },
        async loadCharges() {
            const charges = await this.$http.get("api/yk/getcharges");

            this.charges = charges;
        },
        async loadGradesSetup() {
            this.gradesSetup = await this.$http.get("api/yk/getGradesSetup");
        },
        changeFromNone(student) {
            return (
                student.originalDuration == "NONE" &&
                student.enrollment.regType != "NONE"
            );
        },
        getWeekProperty(index) {
            const weekNumber = 1 + index;

            return "week" + weekNumber;
        },
        getRate() {
            return 3000;
        },
        // resetPrice() {
        //     this.paymentAmount = this.getRate();
        // },
        getPaymentAmount() {
            return this.paymentAmount || this.getRate();
        },

        updateTotal(student, durationUpdated = false) {
            //if (student.isEnrolled) return;

            if (
                student.enrollment.regType == "NONE" &&
                !this.changeFromNone(student)
            ) {
                student.total = 0;
                return;
            }

            student.paymentAmount = this.paymentAmount
                ? this.paymentAmount
                : this.getRate();

            const charges = sum(student.charges.map((c) => +c.paymentAmount));

            student.total = +this.getPaymentAmount(student) + charges;
        },
        resetPrice() {
            const student = this.student;
            this.paymentAmount = this.getRate();

            student.charges.forEach((charge) => {
                const original = this.charges.find(
                    (c) => c.name == charge.name
                );

                charge.paymentAmount = original.amount;
            });

            this.updateTotal(student);
        },
        edit() {
            this.editingAmount = true;
            this.originalAmount = this.paymentAmount || this.getRate();
            this.paymentAmount = this.paymentAmount || this.getRate();
            this.updateTotal(this.student);
        },
        rollbackEditingAmount() {
            this.paymentAmount = "";
            this.editingAmount = false;
            this.originalAmount = 0;

            this.updateTotal(this.student);
        },
        rollback() {
            this.student.enrollment.regType = this.original.enrollment.regType;
            this.student.enrollment.week1 = this.original.enrollment.week1;
            this.student.enrollment.week2 = this.original.enrollment.week2;
            this.student.enrollment.week3 = this.original.enrollment.week3;
            this.student.enrollment.week4 = this.original.enrollment.week4;
            this.student.enrollment.week5 = this.original.enrollment.week5;
            this.student.enrollment.week6 = this.original.enrollment.week6;
            this.student.enrollment.week7 = this.original.enrollment.week7;
            this.student.enrollment.week8 = this.original.enrollment.week8;
            this.student.enrollment.week9 = this.original.enrollment.week9;
            this.student.enrollment.lunchDoc = this.original.enrollment.lunchDoc;
            this.student.enrollment.covidTest = this.original.enrollment.covidTest;
            this.student.enrollment.healthForm = this.original.enrollment.healthForm;
            this.student.enrollment.rulesForm = this.original.enrollment.rulesForm;

            this.paymentAmount = 0;
            this.editingAmount = false;
            this.newStudent = "";
        },
        openDialog(original) {
            this.original = original;

            this.dialogOpen = true;
        },
        cancel() {
            this.rollback();

            this.dialogOpen = false;
        },
        validate() {
            // return (
            //     this.$refs.chosenClass.validate(true) &&
            //     this.$refs.chosenBunk.validate(true)
            // );

            return true;
        },
        async save() {
            if (!this.validate()) return;

            this.processing = true;

            const enrollment = this.student.enrollment;

            const data = {
                familyID: this.account.accountID,
                studentID: this.student.studentID,
                id: enrollment.id,
                regID: this.regID,
                regType: enrollment.regType,
                class: this.student.class,
                // classId: this.student.chosenClass
                //     ? this.student.chosenClass.classID
                //     : "",
                // bunkId: this.student.chosenBunk
                //     ? this.student.chosenBunk.classID
                //     : "",
                chargeCat: "YKC",
                chargeCode: this.regID,
                amount: this.paymentAmount || this.getRate(),
                week1: true,
                week2: true,
                week3: true,
                week4: true,
                week5: true,
                week6: true,
                week7: true,
                week8: true,
                week9: true,
                price: this.getRate(),
            };

            try {
                await this.$http.post(
                    "api/yk/updateEnrollment?user=" +
                        this.$store.state.authentication.user,
                    data
                );

                if (
                    (!this.student.isEnrolled ||
                        this.changeFromNone(this.student)) &&
                    enrollment.duration != "NONE"
                ) {
                    return this.saveCharges();
                }
            } catch (e) {
                this.processing = false;

                return;
            }

            this.processing = false;
            this.dialogOpen = false;

            this.refresh();
        },
        async saveCharges() {
            const charges = this.student.charges.map((charge) => {
                return {
                    studentID: this.student.studentID,
                    chargeName: charge.name,
                    amount: charge.paymentAmount ? charge.paymentAmount : 0,
                };
            });

            try {
                await this.$http.post(
                    "api/yk/saveCharges?user=" +
                        this.$store.state.authentication.user,
                    charges
                );
            } catch (e) {
                this.processing = false;

                return;
            }

            this.processing = false;
            this.dialogOpen = false;

            this.refresh();
        },
    },
};
</script>
